<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel2 clearfix plr30 ptb10">
        <ul class="ul-model4 mt30 clearfix">
          <li>
            <a class="clearfix">
              <div class="imgbox fl">
                <img class="imgtop" :src="getImage(detail.bookImage)" alt="">
              </div>
              <div class="txtbox fl">
                <h2 class="textover">{{ detail.bookName }}</h2>
                <p class="textover" v-if="detail.author !== undefined && detail.author !== ''">责任者：{{ detail.author }}</p>
                <p class="textover" v-if="detail.publishHouse !== undefined && detail.publishHouse !== ''">出版社：{{ detail.publishHouse }}</p>
                <p class="textover" v-if="detail.location !== undefined && detail.location !== ''">馆藏地点：{{ detail.location }}</p>
                <p class="textover" v-if="detail.recommendTime !== undefined && detail.recommendTime !== ''">推荐时间：{{ getTime(detail.recommendTime) }}</p>
                <div class="descstyle" v-if="detail.description !== undefined && detail.description !== ''">简介：{{ detail.description }}</div>
              </div>
            </a>
          </li>
        </ul>
        <comment v-if="detail" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        <right-sidebar
          @pvcount="pvcount"
          :comment-count="commentTotal"
          :comment-gotop="commentOffsettop"
          :comment-show="isCommentshow"
          :title="detail.title"
          :image="getImage(detail.image)"
          :url="this.$route.fullPath"
          ref="rightSidebar"></right-sidebar>
        <go-top></go-top>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/validate'
import { getLiveDetail } from '@/api/live/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import pv from '@/components/amount/pv'
import cfontSize from '@/components/selectfontsize/index'
import crumbs from '@/components/crumbs/index'
export default {
  name: 'recommendbookdetail',
  meta: {
    showHeader: true
  },
  components: {
    Comment,
    RightSidebar,
    goTop,
    pv,
    cfontSize,
    crumbs
  },
  data () {
    return {
      detail: {
        'author': '余秋雨',
        'bookImage': 'https://p5.toutiaoimg.com/img/pgc-image/9ca68078a6fa43d1b311b2c4ec2be5d3~tplv-tt-cs0:640:360.jpg',
        'bookName': '文化苦旅',
        'description': '《文化苦旅》是当代学者、作家余秋雨的一部散文集。于1992年首次出版，是余秋雨先生二十世纪八十年代末和九十',
        'fid': '12117',
        'id': 1,
        'location': '馆藏地址',
        'menuId': 6260,
        'publishHouse': '长江文艺出版社',
        'recommendTime': '2021-07-28 20:24:46'
      },
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      fontsizetype: ''
    }
  },
  mounted () {
    // this.getDetail()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    fontsizeType (val) {
      this.fontsizetype = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    getTime (val) {
      return timeFormat(val, 'yymmdd').replace(/-/g, '/')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 获取信息详情 */
    getDetail () {
      getLiveDetail(this.$route.query.id).then((res) => {
        if (res.data.status === 200) {
          this.detail = res.data.data
          this.detail.updateTime = timeFormat(this.detail.updateTime, 'yymmddhhmm')
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detailmodel2{
  text-align: left;
  padding-top: 2px;
  .ul-model4{
    li{
      a{
        .imgbox{
          width: 20%;
        }
        .txtbox{
          width: 80%;
          padding: 5px 22px 22px;
          h2{
            margin: 0 0 10px;
          }
          .descstyle{
            height: auto;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/recommendbook/bookdetail.vue